import classNames from 'classnames';
import React from 'react';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';

var css_248z = ".Qlmy8,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.RdoeE{color:var(--ricos-settings-text-color,#000);width:100%}[dir] .RdoeE{background-color:#fff}.RdoeE._7MREW{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.RdoeE{height:47px}}}@container (width < 640px){.RdoeE{height:47px}}.RdoeE .oEByE{grid-gap:12px;align-items:center;display:grid;grid-auto-columns:max-content auto max-content;grid-auto-flow:column;height:40px}[dir=ltr] .RdoeE .oEByE,[dir=rtl] .RdoeE .oEByE{padding-left:20px;padding-right:20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.RdoeE .oEByE.AiCpX{grid-auto-columns:auto}}}@container (width < 640px){.RdoeE .oEByE.AiCpX{grid-auto-columns:auto}}.RdoeE .oEByE .sQ6OJ{align-self:left}@supports not (contain:inline-size){@media only screen and (max-width:640px){.RdoeE .oEByE .sQ6OJ{display:flex;width:100%}}}@container (width < 640px){.RdoeE .oEByE .sQ6OJ{display:flex;width:100%}}.RdoeE .oEByE .Q8oQ6{display:grid;grid-auto-flow:row}.RdoeE .oEByE .Q8oQ6 .RuvHX{font-size:14px}.RdoeE .oEByE .Q8oQ6 .bNSQU{color:#646464;font-size:12px}.RdoeE .oEByE .H4mDY{align-self:right}.RdoeE._7MREW,.RdoeE:active{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .RdoeE._7MREW,[dir] .RdoeE:active{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.RdoeE._7MREW svg,.RdoeE:active svg{fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .RdoeE:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.05);cursor:pointer}";
var styles = {"fontElementMap":"Qlmy8","container":"RdoeE","selected":"_7MREW","content":"oEByE","content_mobile_alignCenter":"AiCpX","prefix":"sQ6OJ","titleWrapper":"Q8oQ6","title":"RuvHX","subtitle":"bNSQU","suffix":"H4mDY"};
styleInject(css_248z);

const ListItemSelect = ({
  title,
  subtitle,
  prefix,
  suffix,
  dataHook,
  selected,
  disabled,
  onClick,
  tooltip,
  onKeyDown
}) => {
  return /* @__PURE__ */ React.createElement(Tooltip, { content: tooltip }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.container, {
        [styles.selected]: selected
      }),
      tabIndex: 0,
      onKeyDown,
      "data-hook": dataHook,
      "data-selected": selected,
      onClick: disabled ? void 0 : onClick
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.content, {
          [styles.content_mobile_alignCenter]: !title
        })
      },
      prefix && /* @__PURE__ */ React.createElement("div", { className: styles.prefix }, prefix),
      title && /* @__PURE__ */ React.createElement("div", { className: styles.titleWrapper }, title && /* @__PURE__ */ React.createElement("div", { className: styles.title }, title), subtitle && /* @__PURE__ */ React.createElement("div", { className: styles.subtitle }, subtitle)),
      suffix && /* @__PURE__ */ React.createElement("div", { className: styles.suffix }, suffix)
    )
  ));
};

export { ListItemSelect as default };
//# sourceMappingURL=ListItemSelect.js.map
